import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import PluginService from 'services/PluginService';
import { PLUGINS } from 'queries/query-keys';
import { getChosenBusiness } from 'store/authentication/selectors';
import { getOriginalErrorStatusCode } from 'services/AxiosService';
import type { BusinessAppPreviewInstalls } from './types';

export const useBusinessAppPreviewInstalls = (
  apiName: string,
  previewOwnerId?: string
) => {
  const business = useSelector(getChosenBusiness);
  return useQuery<BusinessAppPreviewInstalls>({
    enabled: Boolean(previewOwnerId),
    queryKey: PLUGINS.GET_BUSINESS_APP_PREVIEW_INSTALLS(
      apiName,
      previewOwnerId
    ),
    queryFn: () =>
      PluginService.getBusinessAppPreviewInstalls(
        business.id,
        apiName,
        previewOwnerId
      ),
    staleTime: 0,
    // Refetched after the preview is deleted or published, while the dialog is still open
    throwOnError: (error) => getOriginalErrorStatusCode(error) !== 404,
  });
};
